export {
    IIMRTabs,
    IMRTabsInitializedArgs,
    IMRTabsOptions,
    IMRTabsState,
    IMRTabsTabSelectedArgs,
    IMRTabsTabSelectingArgs,
} from './tabs/tabs.interfaces'
export { TABS_MODULE_NAME } from './tabs.module'
